collectionGetVariations = function(filteredDataProducts) {
	var variantPrice = [];
	var variantCompareAtPrice = [];

	var prodsWithVariants = [];

	var newlyLoadedProdsWithVariants = [];

	var newlyLoadedProdsHtml;

	var pageProducts = $(".product");

	var filteredDuplicateProducts = [];

	var lowestPrice;
	var highestPrice;
	var highestCompareAtPrice;

	var allPrices = [];
	var allCompareAtPrices = [];

	var variantsPriceRanges = false;
	var variantsSamePrices = false;

	var htmlOutput = '';

	var percentOff;

	var htmlSaleLabel = '<p class="product-sale-tag">' + theme.strings.sale + '</p>';

	var currentProductPrice = '';
	var currentProductCompareAtPrice = '';

	if (filteredDataProducts) {
		pageProducts = $(filteredDataProducts).filter('.product');
	}


	function checkArrValueSameness(array){
		return !array.some(function(value, index, array){
			return value !== array[0];
		});
	}


	function checkIfSale(mainProd) {
		lowestPrice = 0;
		highestPrice = 0;
		highestCompareAtPrice = 0;

		allPrices = [];
		allCompareAtPrices = [];

		variantsPriceRanges = false;
		variantsSamePrices = false;

		htmlOutput = '';

		percentOff = 0;

		currentProductPrice = $(mainProd).eq(0).find('.product-price').data('price');
		currentProductCompareAtPrice = $(mainProd).eq(0).find('.product-price').data('compare-at-price');

		allPrices.push(currentProductPrice);

		if(currentProductCompareAtPrice > 0) {
			allCompareAtPrices.push(currentProductCompareAtPrice);
		}

		$(mainProd).eq(0).find('.variant-price').each(function(){
			if($(this).data('variant-price') > 0){
				allPrices.push($(this).data('variant-price'));
			}
		});


		$(mainProd).eq(0).find('.variant-compare-at-price').each(function(){
			if($(this).data('variant-compare-at-price') > 0) {
				allCompareAtPrices.push($(this).data('variant-compare-at-price'));
			}
		});

		if(allPrices.length > 0) {
			lowestPrice = Math.min.apply(Math, allPrices);

			highestPrice = Math.max.apply(Math, allPrices);
		}

		if(allCompareAtPrices.length > 0){
			highestCompareAtPrice = Math.max.apply(Math, allCompareAtPrices);
		}


		if (highestCompareAtPrice > 0) {
			var largestPrice;

			var arePricesTheSame = checkArrValueSameness(allPrices);

			if(arePricesTheSame === true) {
				percentOff = Math.round((currentProductCompareAtPrice - currentProductPrice) * 100 / currentProductCompareAtPrice);

				htmlOutput = "<p><s>"+theme.Currency.formatMoney(currentProductCompareAtPrice)+"</s></p><p>"+theme.Currency.formatMoney(currentProductPrice)+"</p>";
		 
				$(mainProd).eq(0).find(".product-price").html(htmlOutput);
             
			}
			else {
				percentOff = Math.round((highestCompareAtPrice - lowestPrice) * 100 / highestCompareAtPrice);

				htmlOutput = "<p><s>"+theme.Currency.formatMoney(highestCompareAtPrice)+"</s></p><p>"+theme.Currency.formatMoney(lowestPrice)+"</p>";

				$(mainProd).eq(0).find(".product-price").html(htmlOutput);
              
			}
		}
	}

	function getColourSwatch(p, currentMainProduct, currentMainProductName) {
		var hex = '';

		for(var tag = 0; tag < p.tags.length; tag++) {
			if(p.tags[tag].indexOf("#") > -1) {
				hex = p.tags[tag];
				break;
			}
		}
		if(hex != '') {
			$(currentMainProduct).find(".colour-swatches").append("<div class='swatch-wrapper'><div data-swatch-variant-price="+p.price+" data-swatch-variant-compare-at-price="+p.compare_at_price+"  data-swatch-prod-name='" + p.handle + "' class='swatch swatch-"+ p.handle + "' style='background-color: "+ hex +"' data-swatch-is-variant='true'><span class='sr-only'>" + p.title.trim() + "</span></div></div>\n\r");
		}

	}

	function getPrices(p, currentMainProduct, currentMainProductName){
		$(currentMainProduct).find(".variant-prices").append("<div data-prod-for-price='" + p.handle + "' class='variant-price' data-variant-price="+p.price+" data-variant-compare-at-price="+p.compare_at_price+"> </div>");
	}

	function getFeaturedImage(p, currentMainProduct) {
		if(p.featured_image != null) {
			$(currentMainProduct).find(".product-images").append("<div class='product-image product-image-swatch image-"+p.handle+"'><a href='"+ p.url +"' class='product-featured-image'><img src='"+ p.featured_image +"' alt='"+p.featured_image.alt+"' /></a></div>\n\r");
		}
	}

	function ajaxGetInfo(productColourHandlesArray, currentMainProduct, currentMainProductName, index) {
		var colourHandleName = '';

		jQuery.getJSON('/products/'+productColourHandlesArray+'.js', function(p) {
			if(p.available == true) {
				colourHandleName = productColourHandlesArray;

				getColourSwatch(p, currentMainProduct, currentMainProductName);

				getFeaturedImage(p, currentMainProduct, currentMainProductName);

				getPrices(p, currentMainProduct, currentMainProductName);

				attachImages(p, currentMainProduct, currentMainProductName);

				var indexCount = parseInt(index) + 1;

				prodsWithVariants.push(currentMainProductName);

			}
		});
	}

	function attachImages(p, currentMainProduct) {
		if(p.images.length > 0) {
			for(let i = 0; i < p.images.length; i++) {
				$(currentMainProduct).find(".product-image-slick").append("<img src='"+ p.images[i] +"' data-image-color='" + p.handle + "'/>");
			}
		}
	}

	function getVariantInfo() {
		if(filteredDuplicateProducts.length > 0){
			pageProducts = filteredDuplicateProducts;
		}

		$(pageProducts).each(function(){

			var currentMainProductName = $(this).find(".product-card").data('prod-name');

			var productInfo = $(this).find(".product-card").data('product-info');
			var currentMainProduct = $(this);

			var productColourHandles = $(this).find(".product-card").attr("data-product-other-colour-handles");

			var currentMainProdPrice = $(this).find(".product-price").data('prod-price');
			var currentMainProdCompareAtPrice = $(this).find(".product-price").data('compare-at-price');


			if(productColourHandles) {
				productColourHandlesArray = $.trim(productColourHandles).split(" ");
			}
			else {
				productColourHandlesArray = [];
			}

			variantHandles = [];

			if(productColourHandlesArray.length > 1) {
				for(var i = 0; i < productColourHandlesArray.length; i++) {

					if(productInfo !== productColourHandlesArray[i]) {
						ajaxGetInfo(productColourHandlesArray[i], currentMainProduct, currentMainProductName, i);
					}

				}

			}

		})
	}

	function update() {
		setTimeout(function(){
			$(".product-image-slick").each(function() {
				if($(this).hasClass('slick-initialized') == false) {
					$(this).slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						speed: 300,
						arrows: true,
						prevArrow: $(this).parent().find(".slideshow-block-slides-arrow-left"),
						nextArrow: $(this).parent().find(".slideshow-block-slides-arrow-right")
					})
				}
			});

			$(".swatch-wrapper").click(function(){
				
				var parentProduct = $(this).closest(".product");
				var swatchName = $(this).find('.swatch').attr('class').split(' ')[1];
				var colorName = swatchName.replace('swatch-', '');
				var currentSwatch = '.' + $(this).find('.swatch').attr('class').split(' ')[1];
				var findImage = '.image-' + colorName;
				var isVariant = $(this).find('.swatch').data('swatchIsVariant');

				var swatchPrice = $(this).find('.swatch').data('swatchVariantPrice');
				var swatchCompareAtPrice = $(this).find('.swatch').data('swatchVariantCompareAtPrice')
				

				parentProduct.find(".product-image-swatch").css({"z-index": "-1", "opacity": "0"});

				parentProduct.find(findImage).css({"z-index": "2", "opacity": "1"});
				filterImagesForSwatch(colorName, $(this));

				if(isVariant) {
					parentProduct.find('.product-price').css("display", "none");
					parentProduct.find('.variant-prices').html(generatePriceHTML(swatchPrice, swatchCompareAtPrice));
					
				} else {
					parentProduct.find('.product-price').css("display", "");
					parentProduct.find('.variant-prices').html(null);
				}
			});
		}, 1000);
	}

	function filterImagesForSwatch(colour, currentProd) {
		var slickContainer = $(currentProd).closest(".product-card").find(".product-image-slick");
		$(slickContainer).slick('slickUnfilter');
		$(slickContainer).slick('slickFilter','[data-image-color="' + colour + '"]');
	}

	function generatePriceHTML(price, compareAt) {
		var onSale = price < compareAt ? true : false;

		var saleClasses = onSale ? 'price--on-sale' : '';

		var html = '<dl class="product-price justify-content-center price ' + saleClasses + '" data-price="" data-prod-price="' + price + '" data-compare-at-price="' + compareAt + '"><div class="price__regular"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><span class="price-item price-item--regular" data-regular-price="">' + theme.Currency.formatMoney(price, theme.moneyFormatWithCurrency) + '</span></dd></div><div class="price__sale"><dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt><dd><span class="price-item price-item--sale" data-sale-price="">' + theme.Currency.formatMoney(compareAt, theme.moneyFormatWithCurrency) +'</span><span class="price-item__label sr-only" aria-hidden="true">Sale</span></dd></div></dl>';

		return html;
	}

	
	$(document).ajaxStop(function () {
		update();

		$(".product-image-slick").each(function() {
			if($(this).hasClass('slick-initialized') == false) {
				$(this).slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					speed: 300,
					arrows: true,
					prevArrow: $(this).parent().find(".slideshow-block-slides-arrow-left"),
					nextArrow: $(this).parent().find(".slideshow-block-slides-arrow-right")
				})
			}
        });
	});

	update();

	getVariantInfo();
};
